module.exports = __webpack_public_path__ + "img/Emoji-in-love_gray.f4dd8f30.png";